import CONSTANTS from '../../../constants';

export function product(state = { data: null, loading: true }, action) {
  if (action.type === CONSTANTS.ACTIONS.PRODUCT.PRODUCT_CREATE) {
    const { data } = action;
    return { data: data ? data.response : data, loading: action.loading};
  }
  return state;
}